import { render } from "./TermsConditionsView.vue?vue&type=template&id=244269a9&scoped=true"
import script from "./TermsConditionsView.vue?vue&type=script&lang=js"
export * from "./TermsConditionsView.vue?vue&type=script&lang=js"

import "./TermsConditionsView.vue?vue&type=style&index=0&id=244269a9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244269a9"]])

export default __exports__